<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Varian" subTitle="Forms" />

    <ListVarian />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListVarian from "@/components/Pages/Management/Varian/ListVarian.vue";

export default defineComponent({
  name: "ListVarianPage",
  components: {
    PageTitle,
    ListVarian,
  },
});
</script>
